module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-right.12744e8b.svg";